import React, { useEffect, useState, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { userManager } from '../../utils/Authconfig';

import './header.css';
import logo from '../../assets/logo.svg';
import { Log, UserManager } from 'oidc-client-ts';

function Header({ pageCount, allPages}) {
    const [userFullName, setUserFullName] = useState('User');
    const [userEmail, setUserEmail] = useState('user@example.com');
    const [userInitials, setUserInitials] = useState('U');
    const [errorMessage, setErrorMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);

    const userSectionRef = useRef(null);
    

    useEffect(() => {
        console.log("Fetching user data...");
        userManager.getUser().then(user => {
          console.log("User data received:", user);
          if (user && user.profile) {
            console.log("Setting user info:", user.profile);
            setUserFullName(user.profile.name);
            setUserEmail(user.profile.email);
            const initials = [user.profile.given_name, user.profile.family_name].map(part => part[0]).join('').toUpperCase();
            setUserInitials(initials);
          }
        }).catch(error => console.error('Error fetching user:', error));
    
        const handleClickOutside = (event) => {
          if (showPopup && userSectionRef.current && !userSectionRef.current.contains(event.target)) {
            setShowPopup(false);
          }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showPopup]);


      const handleCloseErrorModal = () => setShowErrorModal(false);
      const handleClosePopup = () => {
        setShowPopup(false);
      };

    return (
        <>
            <div className="header-container">
                <div className="header-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'white', padding: '10px', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                    <div className="brand-container" style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="brand-box" style={{ marginRight: '20px', border: '1px solid #e0f2f7', borderRadius: '5px', padding: '5px', backgroundColor: '#e0f2f7' }}>
                            <img src={logo} alt="logo" className="home-logo small-logo" style={{ height: '28px', width: 'auto' }} />
                        </div>
                        <span className="translator-label small-label" style={{ marginRight: '25px', fontSize: '1.6rem', fontWeight: 'bold' }}>Translator</span>
                        
                        {/* <span className="page-count" style={{ fontSize: '0.9rem', fontWeight: '550' }}>| {pageCount} / {allPages} Remaining </span> */}
                    </div>

                    <div
                        className="user-section"
                        onClick={() => setShowPopup((prevState) => !prevState)}
                        style={{ position: 'relative', cursor: 'pointer' }}
                      
                    >
                        <div className="user-icon">
                            <span>{userInitials}</span>
                        </div>

                        {showPopup && (
                            <>

                                <div className="background-overlay" onClick={handleClosePopup}  />

                                <div className="user-popup" onClick={(e) => e.stopPropagation()}  ref={userSectionRef} >
                                    <div className="user-details">
                                        <div className="user-icon">
                                            <i className="fa fa-user"></i>
                                        </div>
                                        <div className="user-fullname">{userFullName}</div>
                                        <a href={`mailto:${userEmail}`} className="user-email">
                                            {userEmail}
                                        </a>
                                    </div>
                                    <button variant="danger" className="logout-button" onClick={() => userManager.signoutRedirect()} >
                                        <i className="fa-solid fa-right-from-bracket" style={{ marginRight: '8px' }}></i>
                                        Sign Out
                                    </button>
                                    <button className="close-button" onClick={handleClosePopup} >
                                        &times;
                                    </button>
                                </div>
                            </>
                        )}

                    </div>

                </div>


            </div>
            

            <Modal show={showErrorModal} onHide={handleCloseErrorModal} centered className="small-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body className='errormessage'>{errorMessage}</Modal.Body>
                <Modal.Footer>
                    <Button className='error-close' variant="secondary" onClick={handleCloseErrorModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Header;


